<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e920732" style="color: #82a339"><b>WARM LAYERED BEAN DIP</b></p>
<p class="ext" id="d7e921232"><b><i>This colorful dip is always a hit. The pinto bean, Jack cheese, and salsa layers can be assembled several hours in advance, then baked just before serving.</i></b></p>
<p class="h4" id="d7e922532" style="color: #496210"><b>Prep: 35 minutes      Bake: 12 minutes</b></p>
<p class="ul" id="d7e923032">2 garlic cloves, peeled</p>
<p class="ul" id="d7e923332">1 can (15 to 19 ounces) pinto beans, <br/> rinsed and drained</p>
<p class="ul" id="d7e923932">2 green onions, finely chopped</p>
<p class="ul" id="d7e924232">1 tablespoon tomato paste</p>
<p class="ul" id="d7e924532">1 tablespoon water</p>
<p class="ul" id="d7e924932">4 ounces Monterey Jack cheese, shredded (1 cup)</p>
<p class="ul" id="d7e925232">1 cup mild to medium salsa</p>
<p class="ul" id="d7e925532">2 avocados, each cut in half, pitted, and peeled</p>
<p class="ul" id="d7e925832">¼ cup chopped fresh cilantro</p>
<p class="ul" id="d7e926832">3 tablespoons finely chopped red onion</p>
<p class="ul" id="d7e927132">2 tablespoons fresh lime juice</p>
<p class="ul" id="d7e927432">½ teaspoon salt</p>
<p class="ul" id="d7e928332">1 cup sour cream <br/> tortilla chips</p>
<p class="pub" id="d7e929332" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 350°F. In 1-quart saucepan, heat <i>2 cups water </i>to boiling over high heat. Add garlic and cook 3 minutes to blanch; drain. With flat side of chef ’s knife, mash garlic; transfer to medium bowl and add beans, half of green onions, tomato paste, and water. Mash until well combined but still slightly chunky. Spread in bottom of 9-inch glass pie plate.</p>
<p class="pub" id="d7e932132"><span style="color: #c15b49"><b>2.</b></span> Sprinkle cheese over bean mixture, then spread salsa on top. Bake until piping hot, about 12 minutes.</p>
<p class="pub" id="d7e933232"><span style="color: #c15b49"><b>3.</b></span> Meanwhile, in medium bowl, mash avocados just until slightly chunky. Stir in cilantro, red onion, lime juice, and salt. Spoon avocado mixture over hot dip mixture and spread sour cream on top. Sprinkle with remaining green onions. Serve with tortilla chips. Makes about 5½ cups.</p>
<p class="ntx" id="d7e936832">Each tablespoon: About 22 calories, 1g protein, 1g carbohydrate, 2g total fat (1g saturated), 3mg cholesterol, 61mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c15_r1.vue?9ed8abfa